module.exports = __webpack_public_path__ + "img/celular-05.106b3786.png";